import { useEffect, useState } from "react";
import api, { inr } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Lock, PhoneCall, LogOut } from "lucide-react";

export default function LockedScreen({ shop, onLogout, onClose, title, message }) {
  const [info, setInfo] = useState(null);

  useEffect(() => {
    api.get("/subscription").then((r) => setInfo(r.data)).catch(() => setInfo({ admin_phone: "", plans: [] }));
  }, []);

  const plans = info?.plans || [];
  const phone = info?.admin_phone || "";

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-6" data-testid="locked-screen">
      <div className="w-full max-w-lg">
        <div className="bg-card border border-border rounded-xl shadow-sm p-8 text-center">
          <img src="/logo.webp?v=2" alt="Sootrik" className="h-12 w-auto mx-auto mb-4" data-testid="locked-logo" />
          <div className="mx-auto h-14 w-14 rounded-full bg-red-50 flex items-center justify-center mb-4">
            <Lock className="h-7 w-7 text-red-500" />
          </div>
          <span className="inline-block text-xs font-bold uppercase tracking-wider text-red-700 bg-red-100 border border-red-200 rounded-full px-3 py-1 mb-2" data-testid="locked-inactive-badge">Inactive</span>
          <h1 className="font-heading text-2xl font-bold" data-testid="locked-title">{title || "Activate Your Plan"}</h1>
          <p className="text-sm text-muted-foreground mt-2">
            {message ? message : (
              <>
                <span className="font-semibold text-foreground">{shop.name}</span> ki {shop.plan_active ? "plan validity" : "6 din ki free trial"} khatam ho gayi hai, account abhi inactive hai.
                Dobara use karne ke liye Admin se contact karein.
              </>
            )}
          </p>

          {phone && (
            <a
              href={`tel:${phone}`}
              data-testid="locked-call-btn"
              className="mt-5 inline-flex items-center gap-2 bg-cyan-600 hover:bg-cyan-700 text-white font-semibold rounded-full px-6 py-3 text-lg transition-colors"
            >
              <PhoneCall className="h-5 w-5" /> Call Admin: {phone}
            </a>
          )}
          {!phone && info && (
            <p className="mt-5 text-sm text-muted-foreground">Please call the Admin to renew your plan.</p>
          )}
        </div>

        {plans.length > 0 && (
          <div className="mt-5" data-testid="locked-plans">
            <p className="text-xs font-semibold uppercase tracking-wider text-slate-500 mb-2 text-center">Available Plans</p>
            <div className="grid sm:grid-cols-2 gap-3">
              {plans.map((p, i) => (
                <div key={p.id || i} className="bg-card border border-border rounded-xl p-4 text-center" data-testid={`locked-plan-${i}`}>
                  <p className="font-semibold text-sm">{p.name}</p>
                  <p className="text-xs text-muted-foreground mt-0.5">{p.days} days</p>
                  <p className="font-heading text-xl font-bold text-cyan-700 mt-1">{inr(p.price)}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {(info?.payment_qr || info?.payment_number) && (
          <div className="mt-5 bg-card border border-border rounded-xl p-5 text-center space-y-3" data-testid="locked-payment">
            {info.payment_qr && (
              <img src={info.payment_qr} alt="Payment QR" className="h-44 w-44 mx-auto rounded-lg border object-contain" data-testid="locked-payment-qr" />
            )}
            {info.payment_number && (
              <p className="text-sm">Payment Number: <span className="font-bold text-cyan-700" data-testid="locked-payment-number">{info.payment_number}</span></p>
            )}
            <p className="text-xs text-muted-foreground leading-relaxed" data-testid="locked-payment-note">
              To purchase the plan, you can make the payment using the QR code or the provided number. After making the payment, please send the payment screenshot to the given number. Your plan will be activated shortly, and you will be able to log in and start using the services.
            </p>
          </div>
        )}

        <div className="text-center mt-6">
          {onClose ? (
            <Button variant="outline" onClick={onClose} data-testid="locked-back-btn" className="gap-2 px-6 h-10 font-semibold border-slate-300 text-slate-700 hover:bg-slate-100">
              ← Wapas Features par jayein
            </Button>
          ) : (
            <Button variant="outline" onClick={onLogout} data-testid="locked-logout-btn" className="gap-2 px-6 h-10 font-semibold border-slate-300 text-slate-700 hover:bg-slate-100">
              <LogOut className="h-4 w-4" /> Logout — Login screen par wapas jayein
            </Button>
          )}
        </div>
      </div>
    </div>
  );
}
